module.exports = __webpack_public_path__ + "img/user.66fd8894.svg";